import { toastMsg } from '../state/toast';

/** Transient status message. aria-live polite: announced, never steals focus. */
export function Toast() {
  return (
    <div
      aria-live="polite"
      class="pointer-events-none fixed inset-x-0 bottom-16 z-50 flex justify-center px-4"
    >
      {toastMsg.value && (
        <div class="rounded-xl bg-navy-900 px-4 py-2.5 text-sm font-semibold text-white shadow-xl">
          {toastMsg.value}
        </div>
      )}
    </div>
  );
}
